// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2HofY","list":"PatternAutocomplete_list__MBvKC"};